import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { Notification, Styles } from '@contently/toolkit';
import { recShape } from './recommendation_mapper';

const { fonts } = Styles;

const RecDeclineMsg = styled('div')`
  text-align: right;
  font-weight: ${fonts.sans.weight.normal};
  font-size: ${fonts.sans.size.normal};
  font-style: italic;
  line-height: 40px;
`;
RecDeclineMsg.propTypes = {
  children: PropTypes.string.isRequired
};

export default class Recommendation extends React.Component {
  constructor(props) {
    super(props);

    this.state = { showDeclineMsg: false };
  }

  onAccept = () => {
    const { rec } = this.props;
    window.location = rec.primaryAction.href;
  };

  onDecline = () => {
    this.setState({ showDeclineMsg: true });
  };

  render() {
    const { rec, headline, children } = this.props;
    const { showDeclineMsg } = this.state;
    const declineComponent = <RecDeclineMsg>Thanks for your feedback</RecDeclineMsg>;
    const subtext = `Based on data gathered from ${rec.fromDate} - ${rec.toDate}`;

    return (
      <Notification
        headline={headline}
        onAccept={this.onAccept}
        subtext={subtext}
        onDecline={this.onDecline}
        declineButtonMsg="No Thanks"
        acceptButtonMsg={rec.primaryAction.text}
        showDeclineMsg={showDeclineMsg}
        declineComponent={declineComponent}
      >
        {children}
      </Notification>
    );
  }
}

Recommendation.propTypes = {
  rec: recShape.isRequired,
  headline: PropTypes.string.isRequired,
  children: PropTypes.arrayOf(PropTypes.node).isRequired
};



// WEBPACK FOOTER //
// ./app/javascript/app/components/recommendations/recommendation.jsx